import $ from 'jquery';

const SELECTOR = '.link-menu.is-style-sidebar-menu';

function onDocumentReady() {
	const els = $(SELECTOR);

	els.each(initializeElement);
	if (els.length > 0) {
		$(document).on('scroll', () => {
			els.each(updateElement);
		});
	}
}


function initializeElement(i, el) {
	const $el = $(el);
	const links = $('.links > a', el);
	$el.data('links', links);
	$el.data('targets', getTargets(links));

	updateElement(i, el);
}

function updateElement(i, el) {
	const $el = $(el);
	const active = getClosestElementToWindowCenter($el.data('targets'));

	if (active !== $el.data('active')) {
		$el.data('active', active);
		$el.data('links').each((i, link) => {
			$(link).toggleClass('active', link.getAttribute('href') === `#${active.id}`);
		});
	}
}

function getClosestElementToWindowCenter(els) {
	let ret = false;
	let closestDistance = Number.MAX_VALUE;

	els.forEach(el => {
		const distance = distanceFromElementToWindowCenter(el);
		if (distance < closestDistance) {
			closestDistance = distance;
			ret = el;
		}
	});

	return ret;
}

function getTargets($links) {
	const ret = [];

	$links.each((i, el) => {
		const target = document.getElementById(
			el.getAttribute('href').replace(/^#/, '')
		);

		if(target) {
			ret.push(target);
		}
	});

	return ret;
}

function distanceFromElementToWindowCenter(el) {
	const bounds = el.getBoundingClientRect();
	let y = bounds.top;
	if (el.id !== 'overview') {
		y += (bounds.bottom - bounds.top) / 2;
	}

	return Math.abs((window.innerHeight / 2) - y);
}


document.addEventListener('DOMContentLoaded', onDocumentReady);
